import { render, staticRenderFns } from "./ztTabItem.vue?vue&type=template&id=d5bfbfb0&scoped=true&"
import script from "./ztTabItem.vue?vue&type=script&lang=js&"
export * from "./ztTabItem.vue?vue&type=script&lang=js&"
import style0 from "./ztTabItem.vue?vue&type=style&index=0&id=d5bfbfb0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bfbfb0",
  null
  
)

export default component.exports